import * as React from 'react';

import { SocialMediaLinkType } from '../../models/strapi/stateLandingPageQuery';

import { Facebook, Instagram, LinkedIn, Twitter, Youtube } from '../../assets/svg';

interface Props {
    link: SocialMediaLinkType;
    usingMouse: boolean;
}

const StrapiSocialMediaLink = ({ link, usingMouse }: Props) => {
    return (
        <a
            target='__blank'
            href={link.link}
            aria-label={`Visit our ${link.platform} page`}
            className={usingMouse ? 'using-mouse' : ''}>
            {renderSocialMediaIcon(link.platform)}
        </a>
    );
};

const renderSocialMediaIcon = (platform: SocialMediaLinkType['platform']) => {
    switch (platform) {
        case 'facebook': {
            return <Facebook aria-hidden='true' />;
        }
        case 'twitter': {
            return <Twitter aria-hidden='true' />;
        }
        case 'instagram': {
            return <Instagram aria-hidden='true' />;
        }
        case 'youtube': {
            return <Youtube aria-hidden='true' />;
        }
        case 'linkedin': {
            return <LinkedIn aria-hidden='true' />;
        }

        default: {
            return <Facebook aria-hidden='true' />;
        }
    }
};

export default StrapiSocialMediaLink;
